import * as React from "react";

export interface AlertProps {
    text?: string;
    type?: string;
}

export class Alert extends React.Component<AlertProps, {}> {

    render() {
        if (this.props.text == null || this.props.text == "") {
            return <div/>
        } else {
            return <div className={'alert alert-' + this.props.type}>{this.props.text}</div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/form/Alert.tsx